import { render, staticRenderFns } from "./PayrollDeductions.vue?vue&type=template&id=f0c6086e&scoped=true&"
import script from "./PayrollDeductions.vue?vue&type=script&lang=js&"
export * from "./PayrollDeductions.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDeductions.vue?vue&type=style&index=0&id=f0c6086e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6086e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0c6086e')) {
      api.createRecord('f0c6086e', component.options)
    } else {
      api.reload('f0c6086e', component.options)
    }
    module.hot.accept("./PayrollDeductions.vue?vue&type=template&id=f0c6086e&scoped=true&", function () {
      api.rerender('f0c6086e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollDeductions.vue"
export default component.exports